import {pxToRem} from '../../utills/pxToRem'

export const registerModalContent = {
    maxWidth: pxToRem(461),
    borderRadius: 0,
    paddingTop: [pxToRem(30), pxToRem(30), pxToRem(40), pxToRem(40)],
    paddingBottom: [pxToRem(30), pxToRem(30), pxToRem(40), pxToRem(40)],
    paddingLeft: [pxToRem(11), pxToRem(11), pxToRem(20), pxToRem(20)],
    paddingRight: [pxToRem(11), pxToRem(11), pxToRem(20), pxToRem(20)]
}

export const registerModalCloseButton = {
    color: 'black',
    position: 'absolute',
    top: [pxToRem(13), pxToRem(13), pxToRem(13), pxToRem(20)],
    right: [pxToRem(11), pxToRem(11), pxToRem(11), pxToRem(20)],
    height: pxToRem(15),
    minWidth: pxToRem(15)
}
